import {
  Avatar,
  Divider,
  Hidden,
  IconButton,
  Link,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from "@material-ui/core";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import { logout } from "../ducks/actions";
import { useActionRequest, useCongress } from "../hooks";
import useUserMe from "../hooks/useUserMe";

const UserMenu = () => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);

  const { user } = useUserMe();
  const { congress } = useCongress();

  const onMenuOpen = e => {
    setAnchorEl(e.currentTarget);
  };

  const onMenuClose = () => {
    setAnchorEl(null);
  };

  const logoutRequest = useActionRequest({
    action: logout,
    redirect: "/login"
  });

  const onLogout = () => {
    logoutRequest();
  };

  return (
    <>
      <IconButton onClick={onMenuOpen}>
        <Avatar src={user?.profile?.avatarThumb} />
      </IconButton>
      <Menu
        open={Boolean(anchorEl)}
        keepMounted
        anchorEl={anchorEl}
        onClose={onMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        disableAutoFocusItem
      >
        <ListItem dense>
          <ListItemAvatar>
            <Avatar src={user?.profile?.avatarThumb} />
          </ListItemAvatar>
          <ListItemText
            primary={
              <strong>
                {user?.profile?.firstName} {user?.profile?.lastName}
              </strong>
            }
            secondary={user.email}
          />
        </ListItem>
        <ListItem dense>
          <ListItemIcon />
          <ListItemText
            primary={
              <Link component={RouterLink} to="/profile" color="primary">
                {intl.formatMessage({
                  id: "Shared.UserMenu.ManageYourAccount",
                  defaultMessage: "Manage your account"
                })}
              </Link>
            }
          />
        </ListItem>
        <Hidden mdUp>
          {congress.enableFeatureMyBadge && (
            <ListItem dense>
              <ListItemIcon />
              <ListItemText
                primary={
                  <Link component={RouterLink} to="/my-badge" color="primary">
                    {intl.formatMessage({
                      id: "Shared.UserMenu.MyBadge",
                      defaultMessage: "My Badge"
                    })}
                  </Link>
                }
              />
            </ListItem>
          )}
        </Hidden>
        {user?.roles?.includes("accademic") && (
          <ListItem dense>
            <ListItemIcon />
            <ListItemText
              primary={
                <Link component={RouterLink} to="/my-posters" color="primary">
                  {intl.formatMessage({
                    id: "Shared.UserMenu.MyPosters",
                    defaultMessage: "My Posters"
                  })}
                </Link>
              }
            />
          </ListItem>
        )}
        {user?.roles?.includes("speaker") && congress.enableFeaturePresentation && (
          <ListItem dense>
            <ListItemIcon />
            <ListItemText
              primary={
                <Link component={RouterLink} to="/my-presentations" color="primary">
                  {intl.formatMessage({
                    id: "Shared.UserMenu.MyPresentations",
                    defaultMessage: "My Presentations"
                  })}
                </Link>
              }
            />
          </ListItem>
        )}
        {congress.enableFeatureLearn && (
          <ListItem dense>
            <ListItemIcon />
            <ListItemText
              primary={
                <Link component={RouterLink} to="/learn/certificates" color="primary">
                  {intl.formatMessage({
                    id: "Shared.UserMenu.MyCertificates",
                    defaultMessage: "My Certificates"
                  })}
                </Link>
              }
            />
          </ListItem>
        )}

        {(user?.roles?.includes("expert") || user?.roles?.includes("exhibitor")) && (
          <ListItem dense>
            <ListItemIcon />
            <ListItemText
              primary={
                <Link component={RouterLink} to="/meeting-scheduler" color="primary">
                  {intl.formatMessage({
                    id: "Shared.UserMenu.MeetingScheduler",
                    defaultMessage: "Meeting Scheduler"
                  })}
                </Link>
              }
            />
          </ListItem>
        )}

        <Divider />
        <MenuItem button onClick={onLogout}>
          <ListItemText
            primary={intl.formatMessage({
              id: "Shared.UserMenu.SignOut",
              defaultMessage: "Sign out"
            })}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
